import React from "react";
import ErrorDisplay from "@directv-digital/dds.ui.error-display";
import DtvBox from "@directv-digital/dds.ui.dtv-box";
import DtvText from "@directv-digital/dds.ui.dtv-text";
import { OfferRibbonProps } from "../../flip-cards.props";

const styles = {
  offerRibbonStyles: {
    display: "flex",
    padding: {
      xs: "5px 10px",
      md: "10px"
    },
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    flex: "1 0 0",
    borderRadius: "0 0 6px 6px",
    fontSize: "12px !important",
    position: "absolute",
    top: "0px",
    right: "36px"
  }
};

const FlipIcon = () => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.2559 9.41822L14.5052 9.42044C14.2356 10.6614 13.617 11.7994 12.7222 12.7004C11.8274 13.6015 10.6938 14.2281 9.45479 14.5063C8.21579 14.7846 6.92304 14.7029 5.72888 14.271C4.53473 13.8391 3.48889 13.0749 2.71456 12.0684C2.59456 11.9129 2.46255 11.7155 2.46255 11.7155C2.45088 11.6983 2.44277 11.679 2.43868 11.6586C2.43459 11.6382 2.43465 11.6172 2.43879 11.5969C2.44293 11.5765 2.4511 11.5572 2.46282 11.54C2.47454 11.5228 2.48958 11.5082 2.50704 11.4969L3.3617 10.9524C3.39762 10.9295 3.44102 10.9213 3.48284 10.9296C3.52467 10.9378 3.56168 10.962 3.58614 10.9969C3.58614 10.9969 3.7066 11.1747 3.82171 11.32C4.43364 12.0898 5.24664 12.6752 6.17072 13.0115C7.09481 13.3478 8.09393 13.4219 9.0575 13.2255C10.0211 13.0291 10.9115 12.5698 11.6302 11.8987C12.3489 11.2275 12.8679 10.3706 13.1297 9.42267L12.3763 9.42488C12.2181 9.42488 12.1643 9.32045 12.2563 9.192L12.5381 8.79911L13.6817 7.20489C13.6946 7.18286 13.7131 7.16459 13.7353 7.1519C13.7575 7.13921 13.7826 7.13254 13.8081 7.13254C13.8337 7.13254 13.8588 7.13921 13.881 7.1519C13.9031 7.16459 13.9216 7.18286 13.9346 7.20489L13.9768 7.26311L14.491 7.96978L15.0884 8.79156L15.3724 9.18266C15.4675 9.31244 15.4141 9.41733 15.2559 9.41822ZM3.45192 7.2L3.73371 6.80711C3.82616 6.67866 3.77192 6.57378 3.6137 6.57422L2.86083 6.57644C3.12263 5.62876 3.64147 4.77198 4.36001 4.1009C5.07855 3.42982 5.96872 2.97061 6.93206 2.77407C7.8954 2.57754 8.89435 2.65135 9.81835 2.98734C10.7423 3.32332 11.5554 3.90838 12.1675 4.67777C12.2826 4.82222 12.403 5.00133 12.403 5.00133C12.4276 5.03616 12.4645 5.0602 12.5063 5.06848C12.5481 5.07676 12.5915 5.06863 12.6275 5.04578L13.4821 4.50133C13.4996 4.49002 13.5146 4.47532 13.5264 4.45811C13.5381 4.4409 13.5463 4.42153 13.5504 4.40112C13.5546 4.38071 13.5546 4.35968 13.5505 4.33927C13.5464 4.31885 13.5383 4.29945 13.5266 4.28222C13.5266 4.28222 13.3932 4.08489 13.275 3.92933C12.5006 2.92291 11.4547 2.15875 10.2606 1.72686C9.06639 1.29497 7.77367 1.21334 6.53466 1.4916C5.29564 1.76985 4.16196 2.39639 3.26713 3.29742C2.3723 4.19844 1.75362 5.33643 1.48393 6.57733L0.733711 6.58C0.575489 6.58 0.522116 6.68533 0.615005 6.81333L0.899456 7.20445L1.49679 8.02622L2.01057 8.73333L2.055 8.79156C2.06798 8.81348 2.08647 8.83165 2.1086 8.84427C2.13074 8.85689 2.15577 8.86353 2.18125 8.86353C2.20673 8.86353 2.23176 8.85689 2.25389 8.84427C2.27603 8.83165 2.29447 8.81348 2.30744 8.79156L3.451 7.19733L3.45192 7.2Z"
      fill="#121212"
    />
  </svg>
);

const CrossIcon = () => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.1828 10.9406C12.5258 11.2836 12.5258 11.842 12.1828 12.185C12.0112 12.3565 11.7869 12.4444 11.5626 12.4444C11.3383 12.4444 11.114 12.3565 10.9425 12.185L8.00001 9.24329L5.0532 12.185C4.88166 12.3565 4.65734 12.4444 4.43303 12.4444C4.20871 12.4444 3.98439 12.3565 3.81286 12.185C3.46979 11.842 3.46979 11.2836 3.81286 10.9406L6.75532 7.99889L3.81286 5.05718C3.46979 4.7142 3.46979 4.15576 3.81286 3.81278C4.15592 3.4698 4.71453 3.4698 5.0576 3.81278L8.00001 6.75449L10.9425 3.81278C11.2855 3.4698 11.8441 3.4698 12.1872 3.81278C12.5302 4.15576 12.5302 4.7142 12.1872 5.05718L9.24475 7.99889L12.1872 10.9406H12.1828Z"
      fill="white"
    />
  </svg>
);

const OfferRibbon = (props: OfferRibbonProps) => {
  const { offerRibbon, isFlippable, cardType } = props;

  try {
    return (
      <>
        {offerRibbon?.content && <DtvText {...offerRibbon} sx={{
 ...styles.offerRibbonStyles,
background: offerRibbon?.background
}} />}
        {isFlippable && <DtvBox sx={{
 position: "absolute",
top: "8px",
right: "12px"
}}>{cardType === "front" ? <FlipIcon /> : <CrossIcon />}</DtvBox>}
      </>
    );
  } catch (error) {
    return <ErrorDisplay component="OfferRibbon" error={error} />;
  }
};

export default React.memo(OfferRibbon);
